<script>
import { db } from '@/components/Firebase_Conn';
import { auth } from '@/components/Firebase_Conn';
import { storage } from '@/components/Firebase_Conn';
import { jStore } from '@/store/jestionaleStore.js';

const uid = jStore.state.loginStates.userDettails.uid
//console.log(uid)
// REFERENZA UTENTE
const refUtente = db.ref('Utenti/' + uid + '/');
// REFERENZA UTENTE/CLIENTI
const refClienti = db.ref('Utenti/' + uid + '/Clienti/');
// REFERENZA UTENTE/ORDINI
const refOrdini = db.ref('Utenti/' + uid + '/Ordini/');
// REFERENZA UTENTE/ORDINI
const refCategorie_Accessori = db.ref('Utenti/' + uid + '/Categorie_Accessori/');
// REFERENZA UTENTE/ORDINI
const refTipologie = db.ref('Utenti/' + uid + '/Tipologie/');
// REFERENZA UTENTE/ORDINI
const refMarche = db.ref('Utenti/' + uid + '/Marche');
// REFERENZA UTENTE/ORDINI
const refModelli = db.ref('Utenti/' + uid + '/Modelli');
// REFERENZA UTENTE/ORDINI
const refRicambi = db.ref('Utenti/' + uid + '/ricambi');
// REFERENZA UTENTE/ORDINI
const refAccessori = db.ref('Utenti/' + uid + '/Accessori');
// REFERENZA UTENTE/ORDINI
const refListini = db.ref('Utenti/' + uid + '/listini');
//REFERENZA NODO ESTERNO AGLI UTENTI
const refNodoInterno = db.ref('Utenti/' + uid);
//REFERENZA NODO ESTERNO AGLI UTENTI
const refNodoEsterno = db.ref('Altro_mondo');
//REFERENZA NODO ESTERNO AGLI UTENTI
const refTipologieEsterni = db.ref('Altro_mondo/Tipologie');
//REFERENZA NODO ESTERNO AGLI UTENTI
const refRicambiEsterni = db.ref('Altro_mondo/Ricambi');
//REFERENZA CLOUD STORAGE PER IMMAGINI
const refStorageInterno = storage.ref('Utenti/' + uid);
//REFERENZA CLOUD STORAGE PER IMMAGINI
const refStorageEsterno = storage.ref('Altro_mondo');
//Link per bucked storage specifico uic
const urlBucket='https://firebasestorage.googleapis.com/v0/b/jestionale-bfde2.appspot.com/o/Utenti%2F'+uid+'%2F'
const urlBucketEsterno='https://firebasestorage.googleapis.com/v0/b/jestionale-bfde2.appspot.com/o/Altro_mondo%2F'
//DOVE SALVO I PERCORSI DELLE IMMAGINI TEMPORANEE DA ELIMINARE E SVUOTARE ALL'AVVIO
const refChunk = db.ref('Utenti/' + uid + '/chunk_img');
// ARRAY PUNTATORI Clienti, Utente
export const ref = {
  Clienti: refClienti,
  Utente: refUtente,
  uid: uid,
  urlBucket:urlBucket,
  urlBucketEsterno:urlBucketEsterno,
  Ordini: refOrdini,
  Tipologie: refTipologie,
  Marche: refMarche,
  Modelli: refModelli,
  ricambi: refRicambi,
  listini: refListini,
  Accessori: refAccessori,
  Categorie_Accessori:refCategorie_Accessori,

  Interno: refNodoInterno,
  Esterno: refNodoEsterno,
  StorageInterno:refStorageInterno,
  StorageEsterno:refStorageEsterno,
  Chunk: refChunk,
  
  //servono questi 2?
  EsternoTipologie: refTipologieEsterni,
  EsternoRicambi: refRicambiEsterni
};

export default {
  name: 'puntatori'
}

</script>
